import React, { createContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { initialFilterState } from './constants';
import { AppState } from '../../reducers';
import { IFilterState } from './types';
import { ProductCondition, Variant as VariantType } from '../../types';

const initialContextValue: IPriceListFilterContext = {
  filters: initialFilterState,
  setFilters: () => undefined,
};

export const PriceListFilterContext = createContext<IPriceListFilterContext>(
  initialContextValue
);

export const PriceListFilterContextContainer: React.FC = props => {
  const [filters, setFilters] = useState<IFilterState>(initialFilterState);
  const selectedVariant = useSelector(
    (state: AppState) => state.areas.product.variant
  );

  const selectedCondition = useSelector(
    (state: AppState) => state.areas.product.condition
  );
  return (
    <PriceListFilterContext.Provider
      value={{ filters, setFilters, selectedVariant, selectedCondition }}
    >
      {props.children}
    </PriceListFilterContext.Provider>
  );
};

interface IPriceListFilterContext {
  filters: IFilterState;
  selectedVariant?: VariantType | null;
  selectedCondition?: ProductCondition | null;
  setFilters: React.Dispatch<React.SetStateAction<IFilterState>>;
}
